module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="player-pool-filtres">\n	<div class="search-box">\n		<div class="search-box-container">\n			<input 	type="search"\n					name="filter_by_name"\n					id="player-pool-search"\n					value="'+
((__t=( selected['filter_by_name'] ))==null?'':_.escape(__t))+
'"\n					placeholder="Search Players" />\n			<button class="icon player-pool-search-icon js-player-pool-search-icon">\n				<i class="icon ion-ios-search-strong"></i>\n			</button>\n		</div>\n		<div>\n			<input '+
((__t=( selected.is_asc_order ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n			       type="checkbox"\n			       name="is_asc_order"\n			       id="player-pool-order">\n			<label for="player-pool-order" class="icon js-player-pool-sort-asc-desc"></label>\n		</div>\n	</div>\n	<div class="more-filters">\n		<div class="js-player-pool-more-filters-container player-pool-more-filters-container '+
((__t=( !is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<div class="selects-box">\n				<select name="order_by" id="player-pool-order-by">\n					';
 _.each(filter.order_by, function(filter, index){ 
__p+='\n					<option '+
((__t=( selected['order_by'] === filter.key ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( filter.key ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( filter.value ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n				<select name="filter_by_price" id="player-pool-by-price">\n					';
 _.each(filter.by_price, function(filter, index){ 
__p+='\n					<option '+
((__t=( selected['filter_by_price'] === filter.key ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( filter.key ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( filter.value ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n				<select name="filter_by_squad" id="player-pool-by-teams">\n					<option value="">All Teams</option>\n					';
 _.each(filter.squads, function(squad){ 
__p+='\n					<option '+
((__t=( Number(selected['filter_by_squad']) === Number(squad.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( squad.id ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( squad.name ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n				<select name="filter_by_position" id="player-pool-by-positions">\n					<option value="">All positions</option>\n					';
 _.each(filter.positions, function(position){ 
__p+='\n					<option '+
((__t=( Number(selected['filter_by_position']) === Number(position.id) ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					value="'+
((__t=( position.id ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( position.name ))==null?'':_.escape(__t))+
'\n					</option>\n					';
 }) 
__p+='\n				</select>\n			</div>\n			<div class="checkboxes-box">\n				<div>\n					<label for="player-pool-dpp-only">\n						<input '+
((__t=( selected.filter_dpp_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						class="ios-switch"\n						type="checkbox"\n						name="filter_dpp_only"\n						id="player-pool-dpp-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-dpp-only">Show Dual Position players only</label>\n				</div>\n				<div>\n					<label for="player-pool-available-only">\n						<input '+
((__t=( selected.filter_available_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						type="checkbox"\n						class="ios-switch"\n						name="filter_available_only"\n						id="player-pool-available-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-available-only">Show players with an Available Status only</label>\n				</div>\n				<div>\n					<label for="player-pool-favourites-only">\n						<input '+
((__t=( selected.filter_favourite_only ? 'checked' : '' ))==null?'':_.escape(__t))+
'\n						type="checkbox"\n						class="ios-switch"\n						name="filter_favourite_only"\n						id="player-pool-favourites-only">\n						<span class="checkbox"></span>\n					</label>\n					<label for="player-pool-favourites-only">Show watch list</label>\n				</div>\n			</div>\n		</div>\n		<a class="js-player-pool-more-filters player-pool-more-filters-link '+
((__t=( is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<span>More filters</span>\n			<i class="ion-more"></i>\n		</a>\n		<a class="js-player-pool-less-filters player-pool-more-filters-link '+
((__t=( !is_visible_filters ? 'hidden': '' ))==null?'':_.escape(__t))+
'">\n			<span>Show Less filters</span>\n		</a>\n	</div>\n</form>';
}
return __p;
};
